
import { Component } from 'vue-property-decorator';

import RemoteDataTable, {
  RemoteDataField
} from '@/components/RemoteDataTable.vue';

import GlobalAddEdit from '@/views/DashView/Global/GlobalAddEdit.vue';
import { getResponseToMTH } from '@/utils/helpers';
import constants from '@/utils/constants';

class GlobalItem {
  id: string = '';
  cond: string = '';
  code: string = '';
  description: string = '';
}

@Component({
  components: {
    editor: GlobalAddEdit
  }
})
export default class GlobalList extends RemoteDataTable<GlobalItem> {
  public pageTitle: string = 'Global List';

  public newButtonText: string = 'New Global';

  public fieldsSet: Array<RemoteDataField> = [
    new RemoteDataField({ key: 'index', label: '', sortable: false }),
    new RemoteDataField({ key: 'action', label: '', sortable: false }),

    new RemoteDataField({ key: 'cond', label: 'Cond' }),
    new RemoteDataField({ key: 'code', label: 'Code' }),
    new RemoteDataField({ key: 'description', label: 'Description' })
  ];

  // to get page data
  get items(): GlobalItem[] {
    return this.$store.getters.GetAllGlobal;
  }

  get paging(): GlobalItem[] {
    return this.$store.getters.PagingGlobal;
  }

  get sorting(): GlobalItem[] {
    return this.$store.getters.SortingGlobal;
  }

  get filtering(): GlobalItem[] {
    return this.$store.getters.FilteringGlobal;
  }

  sortingChanged(ctx) {
    this.$store.dispatch('UpdateSortingGlobal', {
      byField: ctx.sortBy,
      isDesc: ctx.sortDesc
    });
  }

  filterChanged(isResetFilter) {
    this.$store.dispatch('UpdateFilteringGlobal', {
      isResetFilter: isResetFilter
    });
  }

  reload(id = null) {
    if (id === 1) {
      this.$store.state.global.pagingGlobal.page = 1;
    }
    this.$store.dispatch('GetAllGlobal');
  }

  // delete item
  deleteItem(item) {
    this.$swal({
      title: constants.ARE_YOU_SURE,
      text: constants.CONFIRM_DELETE_ITEM,
      icon: constants.STATUS_WARNING,
      buttons: true,
      dangerMode: true
    }).then(willDelete => {
      if (willDelete) {
        this.$store
          .dispatch('DeleteGlobal', item.id)
          .then(response => {
            getResponseToMTH(response, this.$swal, constants.RECORD_IS_DELETED);
          })
          .catch(error => {
            this.$swal(
              constants.SOMETHING_WROING,
              error.response.data.message,
              constants.STATUS_ERROR
            );
          });
      }
    });
  }

  setPerPage(page) {
    this.$store.state.global.pagingGlobal.size = page;
    this.$store.dispatch('GetAllGlobal');
  }
  mounted() {
    this.reload();
  }
}
